import type { SVGProps } from 'react';

const SvgCeefu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.03768 10.0576L1.55664 12.5396L7.79441 18.7751L10.2755 16.2932L4.03768 10.0576Z"
      fill="#1CD264"
    />
    <path
      d="M10.2744 16.2947L13.6051 12.9627C14.9757 11.5933 17.1971 11.5933 18.5677 12.9627L12.7557 18.776L10.2744 16.2947Z"
      fill="#1CD264"
    />
    <path
      d="M7.79588 1.34058L1.55811 7.57617L4.03915 10.0581L10.2769 3.82249L7.79588 1.34058Z"
      fill="#1CD264"
    />
    <path
      d="M12.7557 1.33862L18.5677 7.15196C17.1971 8.52129 14.9757 8.52129 13.6051 7.15196L10.2744 3.81996L12.7557 1.33862Z"
      fill="#1CD264"
    />
  </svg>
);

export default SvgCeefu;
